import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2 col-md-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-body1 q-pr-md" }, "Agreement type")
], -1)
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "row items-center q-pt-lg" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 col-md-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-body1 q-pr-md" }, "Allow marketing by default")
], -1)
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "row items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 col-md-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-body1 q-pr-md" }, "Exclude digital classrooms")
], -1)
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "row items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "text-body1 q-pr-md" }, "Allow LSP export")
], -1)
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "row items-center q-pb-lg" }
const _hoisted_14 = { class: "col-lg-3 col-md-3" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "q-gutter-md" }
const _hoisted_17 = { class: "row col-gutter-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_agreement_form_field_type = _resolveComponent("agreement-form-field-type")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_agreement_form_field_name = _resolveComponent("agreement-form-field-name")!
  const _component_agreement_form_field_start_date = _resolveComponent("agreement-form-field-start-date")!
  const _component_agreement_form_field_end_date = _resolveComponent("agreement-form-field-end-date")!
  const _component_agreement_form_field_invoicing_allowed_from = _resolveComponent("agreement-form-field-invoicing-allowed-from")!
  const _component_agreement_form_field_price = _resolveComponent("agreement-form-field-price")!
  const _component_agreement_form_field_max_members_allowed = _resolveComponent("agreement-form-field-max-members-allowed")!
  const _component_agreement_form_field_min_length = _resolveComponent("agreement-form-field-min-length")!
  const _component_agreement_form_field_cancel_period = _resolveComponent("agreement-form-field-cancel-period")!
  const _component_agreement_form_field_invoicing_period = _resolveComponent("agreement-form-field-invoicing-period")!
  const _component_agreement_form_field_additional_info = _resolveComponent("agreement-form-field-additional-info")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_agreement_form_field_type, {
          modelValue: _ctx.localModel.type,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localModel.type) = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_q_checkbox, {
          modelValue: _ctx.localModel.allowMarketingCommunication,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localModel.allowMarketingCommunication) = $event)),
          "left-label": ""
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_q_checkbox, {
          modelValue: _ctx.localModel.excludeDigitalClassrooms,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localModel.excludeDigitalClassrooms) = $event)),
          "left-label": ""
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_q_checkbox, {
          modelValue: _ctx.localModel.allowLSPExport,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localModel.allowLSPExport) = $event)),
          "left-label": ""
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("label", {
          class: _normalizeClass([{ 'text-grey': _ctx.disabledEditInSelfService },'text-body1 q-pr-md'])
        }, "Editable in Self-service", 2)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_q_checkbox, {
          modelValue: _ctx.localModel.editableInSelfService,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localModel.editableInSelfService) = $event)),
          "left-label": "",
          disable: _ctx.disabledEditInSelfService
        }, null, 8, ["modelValue", "disable"])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_agreement_form_field_name, {
        modelValue: _ctx.localModel.name,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localModel.name) = $event))
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_agreement_form_field_start_date, {
          modelValue: _ctx.localModel.startDate,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localModel.startDate) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_agreement_form_field_end_date, {
          modelValue: _ctx.localModel.endDate,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localModel.endDate) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_agreement_form_field_invoicing_allowed_from, {
          modelValue: _ctx.localModel.invoicingAllowedFrom,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localModel.invoicingAllowedFrom) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_component_agreement_form_field_price, {
        modelValue: _ctx.localModel.price,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.localModel.price) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_agreement_form_field_max_members_allowed, {
        modelValue: _ctx.localModel.maxMembers,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.localModel.maxMembers) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_agreement_form_field_min_length, {
        modelValue: _ctx.localModel.minLength,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.localModel.minLength) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_agreement_form_field_cancel_period, {
        modelValue: _ctx.localModel.cancelPeriod,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.localModel.cancelPeriod) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_agreement_form_field_invoicing_period, {
        modelValue: _ctx.localModel.invoicingPeriod,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.localModel.invoicingPeriod) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_agreement_form_field_additional_info, {
        modelValue: _ctx.localModel.additionalInfo,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.localModel.additionalInfo) = $event))
      }, null, 8, ["modelValue"])
    ])
  ], 64))
}